import React from "react";
import {useRecoilValue} from "recoil";
import {protectionState} from "../events/recoils";

const BookingConfirmationEmail = () => {
    const refundState = useRecoilValue(protectionState);
    return (
        <>
            {refundState?.protectionSelected && (
                <div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: refundState.refundableConfirmationHtml,
                        }}
                    />

                    <p>
                        If the above content doesn't load, you can also visit:
                        <br />
                        <a
                            href={refundState.refundableLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {refundState.refundableLink}
                        </a>
                    </p>

                    {refundState.saleId && (
                        <p>
                            Sale ID: {refundState.saleId}
                        </p>
                    )}
                </div>
            )}
        </>
    );
};

export default BookingConfirmationEmail;